import styled from 'styled-components'

export const SeeOfferContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0 16px;
`

export const SeeOfferLink = styled.a`
  display: flex;
  width: 100%;
  padding: 14px 16px;
  margin: 16px 0 8px 0;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: #2e2d37;

  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
`
